import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import BillComMDModalContent from "./BillComMDModalContent";


const BillComMDModalWrapper = forwardRef((props: any, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const dialog = useRef<HTMLDialogElement>(null);

  // This function shows the modal
  const show = () => {
    dialog.current?.showModal();
    setIsOpen(true);
  };

  // This function hides the modal
  const hide = () => {
    dialog.current?.close();
    setIsOpen(false);
  };

  // Expose show/hide to parent via ref
  useImperativeHandle(ref, () => ({
    show,
    hide,
  }));

  return (
    <dialog ref={dialog} className="modal rounded-md p-0 overflow-hidden">
      {isOpen && (
        <BillComMDModalContent item={props.item}
          onClose={hide}
          onSelect={(data: any) => {
          }}
        />
      )}
    </dialog>
  );
});

export default BillComMDModalWrapper;